module.exports = __webpack_public_path__ + "media/images/top/about-takumen-420619cdbdd07399eb260647c8c99983.jpg";